/**
 * Game Balance & Calibration Constants
 */

// ⏱️ Время раунда (секунды)
export const ROUND_TIME_LIMIT = 100;

// 🎾 Режим погони за мячиком (секунды)
export const BALL_CHASE_TIME_LIMIT = 10; // Время на поимку убегающего мячика
export const BALL_SPEED = 5.2; // Плавная естественная скорость качения мячика
export const BALL_CHAOS_REWARD = 25; // Награда очков хаоса за поимку

// ⚡ Режим «Тыгыдык» (Спринт)
export const CAT_BASE_SPEED = 4.0;
export const CAT_TYGYDYK_SPEED = 8.0; // Скорость в режиме тыгыдыка (х2)
export const TYGYDYK_MAX = 100;
export const TYGYDYK_DRAIN_RATE = 35; // Расход шкалы тыгыдыка в секунду
export const TYGYDYK_RECOVERY_RATE = 22; // Восстановление в покое

// 💥 Параметры хаоса
export const CHAOS_GOAL = 100;
